<template>
  <button
    type="button"
    class="nav-toggle px-2 py-2 font-rounded text-sm font-bold transition"
    :class="active ? 'opacity-100' : 'opacity-60 hover:opacity-100'"
    @click="emit('select', value)"
  >
    <span class="relative inline-block">
      {{ label }}
      <!-- underline spans the full width of the text -->
      <span
        class="absolute bottom-0 left-0 h-[2px] w-full rounded-full transition-opacity"
        :class="active ? 'bg-[#412c71] opacity-100' : 'bg-[#412c71] opacity-0'"
        aria-hidden="true"
      ></span>
    </span>
  </button>
</template>

<script setup lang="ts">
type Props = {
  label: string;
  value: string;
  active: boolean;
};

defineProps<Props>();

const emit = defineEmits<{
  (e: "select", v: string): void;
}>();
</script>

<style scoped>
.nav-toggle {
  /* Extra bold */
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #412c71;
  /* Figma dark purple */
}

/* underline uses same brand color handled via inline classes */
</style>
